export const EVENT_LOG = 'EVENT_LOG'